import { SUCCESS } from '../../../../constants/action-postfix'
import { COMMISSION_LIST_REQUEST } from '../commissionActionTypes'

const initialState = []

export const commissionListReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${COMMISSION_LIST_REQUEST}${SUCCESS}`:
      return action.payload

    default:
      return state
  }
}
